import { createAction, props } from '@ngrx/store';

export interface CachedData {
  data: any;
  timestamp: number;
  expiry?: number;
}

// Cache Actions
export const setData = createAction(
  '[Cache] Set Data',
  props<{ key: string; data: CachedData }>()
);

export const clearData = createAction(
  '[Cache] Clear Data',
  props<{ key: string }>()
);

export const clearAll = createAction('[Cache] Clear All');

export const cleanExpired = createAction('[Cache] Clean Expired');
